import React from 'react';
import { Container } from 'react-bootstrap';

function TermsOfService() {
    return (
        <Container className="text-white py-5" style={{ minHeight: '80vh' }}>
            <h1 className="fw-bold mb-4">Terms of Service</h1>
            <p>Last Updated: {new Date().toLocaleDateString()}</p>

            <section className="mb-4">
                <h2>1. Agreement to Terms</h2>
                <p>
                    By accessing or using the website and services provided by Qcoda LLC ("Company," "we," "us," or "our"),
                    located in Pennsylvania, you agree to be bound by these Terms of Service. If you do not agree to these terms,
                    please do not use our services.
                </p>
            </section>

            <section className="mb-4">
                <h2>2. Description of Service</h2>
                <p>
                    Qcoda provides an AI-powered software development platform designed to streamline development processes.
                    We are currently in a private beta phase. Features and availability may change without notice.
                </p>
            </section>

            <section className="mb-4">
                <h2>3. User Accounts</h2>
                <p>
                    To access certain features, you may be required to register for an account. You agree to provide accurate,
                    current, and complete information during the registration process and to update such information to keep it accurate,
                    current, and complete. You are responsible for safeguarding your password and for all activities that occur under your account.
                </p>
            </section>

            <section className="mb-4">
                <h2>4. Intellectual Property</h2>
                <p>
                    The service and its original content, features, and functionality are and will remain the exclusive property of
                    Qcoda LLC and its licensors. The service is protected by copyright, trademark, and other laws of both the
                    United States and foreign countries.
                </p>
            </section>

            <section className="mb-4">
                <h2>5. Limitation of Liability</h2>
                <p>
                    In no event shall Qcoda LLC, nor its directors, employees, partners, agents, suppliers, or affiliates,
                    be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation,
                    loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of
                    or inability to access or use the service.
                </p>
            </section>

            <section className="mb-4">
                <h2>6. Governing Law</h2>
                <p>
                    These Terms shall be governed and construed in accordance with the laws of Pennsylvania, United States,
                    without regard to its conflict of law provisions.
                </p>
            </section>

            <section className="mb-4">
                <h2>7. Changes</h2>
                <p>
                    We reserve the right, at our sole discretion, to modify or replace these Terms at any time.
                    By continuing to access or use our Service after those revisions become effective, you agree
                    to be bound by the revised terms.
                </p>
            </section>

            <section className="mb-4">
                <h2>8. Contact Us</h2>
                <p>
                    If you have any questions about these Terms, please contact us.
                </p>
            </section>
        </Container>
    );
}

export default TermsOfService;
